












import { Component, Vue } from "vue-property-decorator";
import FormConcursoPublico from "@/components/Formularios/ConcursosPublicos/FormularioConcursoPublico.vue";

@Component({
  components: {
    FormConcursoPublico
  },
  meta: {
    // sets document title
    title:
      "Postulación Concursos Públicos - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class FormularioConcursoPublicoView extends Vue {
  private mounted() {
    document.title =
      "Solicitud Concursos Públicos - Ilustre Municipalidad de Punta Arenas";
  }
}
